import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Path,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(
          Path,
          {
            d: "M12 17c5 0 8-2.69 8-6H4c0 3.31 3 6 8 6Zm-4 4h8m-4-3v3M5.14 11a3.5 3.5 0 1 1 6.71 0",
            stroke: `${color}`
          }
        ),
        /* @__PURE__ */ jsx(Path, { d: "M12.14 11a3.5 3.5 0 1 1 6.71 0", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M15.5 6.5a3.5 3.5 0 1 0-7 0", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "IceCream2";
const IceCream2 = memo(themed(Icon));
export {
  IceCream2
};
//# sourceMappingURL=ice-cream-2.js.map
